export const comparativeQuestions = [
  {
    id: 1,
    koreanQuestion:
      "이 아파트는 딱  _____ 비싸다 아파트 만큼 그...우리가 본 어제",
    question:
      "This apartment is just ______ expensive as the one we saw yesterday.",
    choices: {
      A: "as",
      B: "more",
      C: "most",
      D: "so",
    },
    correctAnswer: "A",
    explanation: "A: -만큼 B:더 C: 가장 D: 너무 ",
    translation: "이 아파트는 우리가 어제 본 아파트만큼 비싸다.",
    type: "comparative",
  },
  {
    id: 2,
    koreanQuestion: "수정된 계약서는 _______ 원본 계약서보다 ",
    question: "The revised contract is ______ than the original one.",
    choices: {
      A: "clear",
      B: "clearer",
      C: "clearest",
      D: "most clear",
    },
    correctAnswer: "B",
    explanation:
      "A: 명확하다 (원급 형용사) B: 더 명확한 (비교급) C: 가장 명확하다 (최상급) D: 가장 명확한 (최상급의 다른 형태)",
    translation: "수정된 계약서는 원본보다 더 명확하다.",
    type: "comparative",
  },
  {
    id: 3,
    koreanQuestion: "새 소프트웨어는 실행한다 _______ 이전 버전보다 ",
    question: "The new software runs ______ than the previous version.",
    choices: {
      A: "efficient",
      B: "efficiently",
      C: "more efficiently",
      D: "most efficient",
    },
    correctAnswer: "C",
    explanation:
      "A: 효율적인(형용사) B: 효율적으로(부사) C: 더 효율적으로(비교급 부사) D: 가장 효율적인(최상급 형용사)",
    translation: "새 소프트웨어는 이전 버전보다 더 효율적으로 실행된다.",
    type: "comparative adverb",
  },
  {
    id: 4,
    koreanQuestion:
      "새로운 마케팅 전략은 ___  성공적인 캠페인이었다 회사 역사상",
    question:
      "The new marketing strategy was the ______ successful campaign in the company's history.",
    choices: {
      A: "more",
      B: "most",
      C: "much",
      D: "best",
    },
    correctAnswer: "B",
    explanation:
      "A: 더(비교급) B: 가장(최상급) C: 훨씬(비교급 강조) D: 최고의(good의 최상급)",
    translation: "새로운 마케팅 전략은 회사 역사상 가장 성공적인 캠페인이었다.",
    type: "superlative",
  },
  {
    id: 5,
    koreanQuestion: "모든 후보 중에서, 그녀가 ____ 적합하다 그 직책에 ",
    question:
      "Among all the candidates, she is the ______ qualified for the position.",
    choices: {
      A: "most",
      B: "more",
      C: "better",
      D: "best",
    },
    correctAnswer: "A",
    explanation:
      "A: 가장(최상급) B: 더(비교급) C: 더 좋은(good의 비교급) D: 최고의(good의 최상급)",
    translation: "모든 후보 중에서, 그녀가 그 직책에 가장 적합하다.",
    type: "superlative",
  },
  {
    id: 6,
    koreanQuestion:
      "이 부서는 처리한다 업무들을  _______ 다른 어떤 부서보다 회사내에서",
    question:
      "This department handles tasks ______ than any other in the company.",
    choices: {
      A: "efficiently",
      B: "more efficiently",
      C: "most efficiently",
      D: "efficient",
    },
    correctAnswer: "B",
    explanation:
      "A: 효율적으로(원급 부사) B: 더 효율적으로(비교급 부사) C: 가장 효율적으로(최상급 부사) D: 효율적인(형용사)",
    translation:
      "이 부서는 회사 내 다른 어떤 부서보다 더 효율적으로 업무를 처리한다.",
    type: "comparative adverb",
  },
  {
    id: 7,
    koreanQuestion: "새 모델은 _______  저렴하다 사용 가능한 모든 옵션 중에서",
    question:
      "The new model is the ______ affordable among all available options.",
    choices: {
      A: "more",
      B: "most",
      C: "much",
      D: "best",
    },
    correctAnswer: "B",
    explanation: "A: 더(more) B: 가장(most) C: 매우(much) D: 최고의(best)",
    translation: "새 모델은 사용 가능한 모든 옵션 중에서 가장 저렴하다.",
    type: "superlative",
  },
  {
    id: 8,
    koreanQuestion: "세 명의 후보 중에서, 그녀가 _______  적합하다 그 직책에",
    question:
      "Of the three candidates, she is the ______ qualified for the position.",
    choices: {
      A: "most",
      B: "more",
      C: "better",
      D: "best",
    },
    correctAnswer: "A",
    explanation: "A: 가장(most) B: 더(more) C: 더 좋은(better) D: 최고의(best)",
    translation: "세 명의 후보 중에서, 그녀가 그 직책에 가장 적합하다.",
    type: "superlative",
  },
  {
    id: 9,
    koreanQuestion:
      "새로운 소프트웨어는 실행한다 _______ 더 효율적으로 이전 버전보다 ",
    question:
      "The new software runs ______ more efficiently than the previous version.",
    choices: {
      A: "very",
      B: "even",
      C: "so",
      D: "quite",
    },
    correctAnswer: "B",
    explanation: "A: very(매우) B: even(훨씬 더) C: so(너무) D: quite(꽤)",
    translation:
      "새로운 소프트웨어는 이전 버전보다 훨씬 더 효율적으로 실행됩니다.",
    type: "comparative intensifier",
  },
  {
    id: 10,
    koreanQuestion: "최신 스마트폰 모델은 _______ 더 얇다 작년 버전보다",
    question:
      "The latest smartphone model is ______ thinner than last year's version.",
    choices: {
      A: "still",
      B: "very",
      C: "enough",
      D: "such",
    },
    correctAnswer: "A",
    explanation:
      "A: still(여전히 더) B: very(매우) C: enough(충분히) D: such(그런)",
    translation: "최신 스마트폰 모델은 작년 버전보다 여전히 더 얇다.",
    type: "comparative intensifier",
  },
  {
    id: 11,
    koreanQuestion:
      "새 사무실은 _______ 더 크다 이전 것 보다 , 수용하면서 더 많은 직원을",
    question:
      "The new office is ______ larger than the previous one, allowing for more employees.",
    choices: {
      A: "far",
      B: "too",
      C: "well",
      D: "quite",
    },
    correctAnswer: "A",
    explanation: "A: far(훨씬 더) B: too(너무) C: well(잘) D: quite(꽤)",
    translation:
      "새 사무실은 이전 사무실보다 훨씬 더 커서, 더 많은 직원을 수용할 수 있다.",
    type: "comparative intensifier",
  },
  {
    id: 12,
    koreanQuestion: "올해의 매출 실적은 _______ 더 좋다 작년보다 ",
    question:
      "This year's sales performance is ______ better than last year's.",
    choices: {
      A: "a lot",
      B: "very",
      C: "almost",
      D: "rather",
    },
    correctAnswer: "A",
    explanation:
      "A: a lot(훨씬 더) B: very(매우) C: almost(거의) D: rather(다소)",
    translation: "올해의 매출 실적은 작년보다 훨씬 더 좋다.",
    type: "comparative intensifier",
  },
  {
    id: 13,
    koreanQuestion:
      "이 작업은 _______ 이전 작업 보다, 그래서 시간이 더 걸릴 수 있습니다.",
    question:
      "This task is ______ than the previous one, so it may take more time.",
    choices: {
      A: "more difficult",
      B: "more harder",
      C: "very difficult",
      D: "most difficult",
    },
    correctAnswer: "A",
    explanation:
      "A: more difficult(더 어려운) B: more harder(더 더 어려운-중복 표현) C: very difficult(매우 어려운) D: most difficult(가장 어려운)",
    translation:
      "이 작업은 이전 작업보다 더 어렵기 때문에 시간이 더 걸릴 수 있습니다.",
    type: "basic comparative",
  },
  {
    id: 14,
    koreanQuestion: "업데이트된 소프트웨어는 실행한다 _______ 이전 버전보다  ",
    question: "The updated software runs ______ than the previous version.",
    choices: {
      A: "more faster",
      B: "much faster",
      C: "very faster",
      D: "most faster",
    },
    correctAnswer: "B",
    explanation:
      "A: more faster(더 더 빠른-중복 표현) B: much faster(훨씬 더 빠른) C: very faster(매우 더 빠른-문법적으로 불가능) D: most faster(가장 더 빠른-문법적으로 불가능)",
    translation:
      "업데이트된 소프트웨어는 이전 버전보다 훨씬 더 빠르게 실행됩니다.",
    type: "comparative with intensifier",
  },
  {
    id: 15,
    koreanQuestion:
      "새로운 마케팅 전략은 _______ 성공적이었다 이전 마케팅 전략보다 ",
    question:
      "The new marketing strategy was ______ successful than the previous one.",
    choices: {
      A: "very",
      B: "most",
      C: "more better",
      D: "much more",
    },
    correctAnswer: "D",
    explanation:
      "A: very(매우) - 비교급과 함께 사용 불가 B: most(가장) - 최상급으로 부적절 C: more better(더 더 좋은) - 이중 비교급으로 문법적 오류 D: much more(훨씬 더) - 비교급을 강조하는 올바른 표현",
    translation: "새로운 마케팅 전략은 이전 전략보다 훨씬 더 성공적이었다.",
    type: "comparative with intensifier",
  },
  {
    id: 16,
    koreanQuestion: "새 사무실 공간은 _______ 더 크다 이전 것 보다",
    question: "The new office space is ______ larger than the previous one.",
    choices: {
      A: "more",
      B: "much",
      C: "very",
      D: "most",
    },
    correctAnswer: "B",
    explanation:
      "A: more(더) - 이미 비교급인 larger와 함께 사용 불가 B: much(훨씬) - 비교급을 강조하는 올바른 표현 C: very(매우) - 비교급을 수식할 수 없음 D: most(가장) - 최상급을 만들 때 사용되므로 부적절",
    translation: "새 사무실 공간은 이전 사무실보다 훨씬 더 크다.",
    type: "comparative with intensifier",
  },
  {
    id: 17,
    koreanQuestion: "두 프로젝트 중에서, 이것이 _______  실행 가능성이 높다",
    question: "Of the two projects, this one is the ______ feasible.",
    choices: {
      A: "more",
      B: "most",
      C: "much",
      D: "very",
    },
    correctAnswer: "A",
    explanation:
      "A: more(더) - 두 개 중 비교에 적절 B: most(가장) - 셋 이상의 최상급 비교에 사용되므로 부적절 C: much(훨씬) - 비교급 강조 부사로만 사용 가능 D: very(매우) - 비교급과 함께 사용 불가",
    translation: "두 프로젝트 중에서, 이것이 더 실행 가능성이 높다.",
    type: "comparative with of the two",
  },
  {
    id: 18,
    koreanQuestion: "두 후보 중에서 Mr. Kim이 _______ 경험이 많다",
    question: "Of the two candidates, Mr. Kim is the ______ experienced.",
    choices: {
      A: "more",
      B: "most",
      C: "best",
      D: "highly",
    },
    correctAnswer: "A",
    explanation:
      "A: more(더) B: most(가장)  C: best(최고의) D: highly(매우) - 비교급으로 사용 불가",
    translation: "두 후보 중에서 Mr. Kim이 더 경험이 많다.",
    type: "comparative with of the two",
  },
  {
    id: 19,
    koreanQuestion: "두 가지 해결책 중에서 첫 번째 것이 _______ 효과적이다",
    question: "Of the two solutions, the first one is the ______ effective.",
    choices: {
      A: "more",
      B: "most",
      C: "the most",
      D: "better",
    },
    correctAnswer: "A",
    explanation:
      "A: more(더) - 두 개 중 비교에 적절 B: most(가장) - 셋 이상의 최상급 비교에 사용되므로 부적절 C: the most(가장) - 셋 이상의 최상급 비교에 사용되므로 부적절 D: better(더 나은) - effective의 비교급이 아님",
    translation: "두 가지 해결책 중에서 첫 번째 것이 더 효과적이다.",
    type: "comparative with of the two",
  },
  {
    id: 20,
    koreanQuestion: "두 디자인 중에서, 이것이 _______  매력적이다",
    question: "Of the two designs, this one is the ______ attractive.",
    choices: {
      A: "more",
      B: "most",
      C: "very",
      D: "best",
    },
    correctAnswer: "A",
    explanation:
      "A: more(더) - 두 개 중 비교에 적절 B: most(가장) - 셋 이상의 최상급 비교에 사용되므로 부적절 C: very(매우) - 비교급과 함께 사용 불가 D: best(최고의) - attractive의 비교급이 아님",
    translation: "두 디자인 중에서, 이것이 더 매력적이다.",
    type: "comparative with of the two",
  },
  {
    id: 21,
    koreanQuestion: "두 보고서 중에서, 두 번째 것이 _______ 상세하다",
    question: "Of the two reports, the second one is the ______ detailed.",
    choices: {
      A: "more",
      B: "most",
      C: "much",
      D: "extremely",
    },
    correctAnswer: "A",
    explanation:
      "A: more(더) - 두 개 중 비교에 적절 B: most(가장) - 셋 이상의 최상급 비교에 사용되므로 부적절 C: much(훨씬) - 비교급 강조 부사로만 사용 가능 D: extremely(매우) - 비교급과 함께 사용 불가",
    translation: "두 보고서 중에서, 두 번째 것이 더 상세하다.",
    type: "comparative with of the two",
  },

  {
    id: 22,
    koreanQuestion: "당신이 준비할수록 시험을,  더 높아진다 가능성이 합격할",
    question:
      "The ______ you prepare for the exam, the higher your chances of passing.",
    choices: {
      A: "much",
      B: "more",
      C: "very",
      D: "many",
    },
    correctAnswer: "B",
    explanation: "A: much(많이) B: more(더 많이) C: very(매우) D: many(많은)",
    translation: "시험을 더 많이 준비할수록, 합격할 가능성이 더 높아진다.",
    type: "comparative idiom",
  },
  {
    id: 23,
    koreanQuestion: "새로운 시스템은 처리한다 데이터를 _______ 이전 버전보다 ",
    question: "The new system processes data ______ than the previous version.",
    choices: {
      A: "faster",
      B: "fastest",
      C: "more fast",
      D: "fast",
    },
    correctAnswer: "A",
    explanation:
      "A: faster(더 빠르게) B: fastest(가장 빠르게) C: more fast(더 빠르게-잘못된 형태) D: fast(빠르게)",
    translation: "새로운 시스템은 이전 버전보다 더 빠르게 데이터를 처리한다.",
    type: "comparative adverb",
  },
  {
    id: 24,
    koreanQuestion: "마케팅 캠페인은 도달했다 잠재 고객에게 _______ 예상보다",
    question:
      "The marketing campaign reached potential customers ______ than expected.",
    choices: {
      A: "effectively",
      B: "more effectively",
      C: "most effective",
      D: "more effective",
    },
    correctAnswer: "B",
    explanation:
      "A: effectively(효과적으로) B: more effectively(더 효과적으로) C: most effective(가장 효과적인) D: more effective(더 효과적인)",
    translation:
      "마케팅 캠페인은 예상보다 더 효과적으로 잠재 고객에게 도달했다.",
    type: "comparative adverb",
  },
  {
    id: 25,
    koreanQuestion: "수정된 매뉴얼은 설명한다 절차를  _______ 이전 메뉴얼보다",
    question:
      "The revised manual explains the procedures ______ than the old one.",
    choices: {
      A: "clearer",
      B: "more clearly",
      C: "most clear",
      D: "more clear",
    },
    correctAnswer: "B",
    explanation:
      "A: clearer(더 명확한) B: more clearly(더 명확하게) C: most clear(가장 명확한) D: more clear(더 명확한)",
    translation: "수정된 매뉴얼은 이전 것보다 더 명확하게 절차를 설명한다.",
    type: "comparative adverb",
  },
  {
    id: 28,
    koreanQuestion: "팀은 대응했다 위기에  _______ 기대한것보다",
    question: "The team responded to the crisis ______ than anticipated.",
    choices: {
      A: "quick",
      B: "quicker",
      C: "more quickly",
      D: "more quick",
    },
    correctAnswer: "C",
    explanation:
      "A: quick(빠른) B: quicker(더 빠른) C: more quickly(더 빠르게) D: more quick(더 빠른-잘못된 형태)",
    translation: "팀은 예상보다 더 신속하게 위기에 대응했다.",
    type: "comparative adverb",
  },
  {
    id: 29,
    koreanQuestion:
      "회사는 성장하고 있다 _______ 우리가 처음 예측했던 것보다  ",
    question: "The company is growing ______ than we initially predicted.",
    choices: {
      A: "rapid",
      B: "rapidly",
      C: "more rapidly",
      D: "most rapid",
    },
    correctAnswer: "C",
    explanation:
      "A: rapid(빠른) B: rapidly(빠르게) C: more rapidly(더 빠르게) D: most rapid(가장 빠른)",
    translation: "회사는 우리가 처음 예측했던 것보다 더 빠르게 성장하고 있다.",
    type: "comparative adverb",
  },
  {
    id: 30,
    koreanQuestion:
      "새 모델은 바람직하다 ______ 이전 버전 향상된 배터리 수명 덕분에",
    question:
      "The new model is preferable ______ the older version due to its improved battery life.",
    choices: {
      A: "than",
      B: "to",
      C: "rather than",
      D: "over",
    },
    correctAnswer: "B",
    explanation: "preferable to 는 ~보다 더 바람직한 이라는 의미",
    translation:
      "새 모델은 향상된 배터리 수명 덕분에 이전 버전보다 더 바람직하다.",
    type: "preference comparison",
  },
  {
    id: 31,
    koreanQuestion: "나는 머무는것이 좋다 집에 외출하는 것보다 이 날씨에",
    question: "I would rather stay home ______ go out in this weather.",
    choices: {
      A: "than",
      B: "to",
      C: "over",
      D: "instead",
    },
    correctAnswer: "A",
    explanation: "A: than(~보다) B: to(~에) C: over(~보다) D: instead(대신에)",
    translation: "나는 이런 날씨에 외출하는 것보다 집에 있는 것이 좋겠다.",
    type: "preference comparison",
  },
  {
    id: 32,
    koreanQuestion: "대부분의 소비자는 더 선호한다 유기농 식품을 가공식품보다",
    question: "Most consumers prefer organic food ______ processed food.",
    choices: {
      A: "than",
      B: "to",
      C: "over",
      D: "instead of",
    },
    correctAnswer: "B",
    explanation: "prefer A to B(B보다 A를 선호하다)",
    translation: "대부분의 소비자는 가공식품보다 유기농 식품을 더 선호한다.",
    type: "preference comparison",
  },
  {
    id: 33,
    koreanQuestion:
      "나는 머무르는게 더 낫다 저렴한 호텔에 소비하는 것보다 많이 숙박에",
    question:
      "I would rather stay in a budget hotel ______ spend too much on accommodation.",
    choices: {
      A: "than",
      B: "to",
      C: "instead of",
      D: "rather than",
    },
    correctAnswer: "A",
    explanation:
      "A: than(~보다) B: to(~에) C: instead of(~대신에) D: rather than(~보다는)",
    translation:
      "나는 숙박비를 너무 많이 쓰는 것보다 저렴한 호텔에 머무르는 것이 낫다.",
    type: "preference comparison",
  },
  {
    id: 34,
    koreanQuestion: "회사의 이윤율이 _______ 더 높다 작년 이윤율보다",
    question: "The company's profit margin is ______ higher than last year's.",
    choices: {
      A: "very",
      B: "even",
      C: "too",
      D: "extremely",
    },
    correctAnswer: "B",
    explanation:
      "A: very(매우) B: even(훨씬) C: too(너무) D: extremely(극도로)",
    translation: "회사의 이윤율이 작년보다 훨씬 더 높다.",
    type: "comparative intensifier",
  },
  {
    id: 35,
    koreanQuestion:
      "수정된 일정이 _______ 길어졌다 우리가 처음 예상했던 것보다",
    question:
      "The revised schedule is ______ longer than we initially expected.",
    choices: {
      A: "still",
      B: "very",
      C: "highly",
      D: "absolutely",
    },
    correctAnswer: "A",
    explanation:
      "still'은 비교급을 강조할 때 사용되는 적절한 부사로, 한층 더 ~한 의 의미를 가집니다",
    translation: "수정된 일정이 우리가 처음 예상했던 것보다 한층 더 길어졌다.",
    type: "comparative intensifier",
  },
  {
    id: 36,
    koreanQuestion: "새로운 제품이 _______ 가장 인기가 많다 소비자들 사이에서",
    question: "The new product is ______ the most popular among consumers.",
    choices: {
      A: "very",
      B: "by far",
      C: "more",
      D: "mostly",
    },
    correctAnswer: "B",
    explanation:
      "A: very(매우) B: by far(단연코) C: more(더) D: mostly(대부분)",
    translation: "새로운 제품이 소비자들 사이에서 단연코 가장 인기가 많다.",
    type: "superlative intensifier",
  },
  {
    id: 40,
    koreanQuestion: "비행기는 도착했다. _______ 예상보다 강한 맞바람으로 인해 ",
    question: "The plane arrived ______ than expected due to strong headwinds.",
    choices: {
      A: "late",
      B: "lately",
    },
    correctAnswer: "A",
    explanation: "A: late(늦게) B: lately(최근에)",
    translation: "비행기는 강한 맞바람으로 인해 예상보다 늦게 도착했다.",
    type: "special adverb",
  },
  {
    id: 41,
    koreanQuestion:
      "이것은  _______ 가장 성공적인 제품이다 그.. 우리 회사가 현재 출시했던",
    question:
      "This is ______ the most successful product our company has ever launched.",
    choices: {
      A: "much",
      B: "even",
      C: "far",
      D: "by far",
    },
    correctAnswer: "D",
    explanation: "A: much(훨씬) B: even(심지어) C: far(멀리) D: by far(단연코)",
    translation:
      "이것은 우리 회사가 출시한 제품 중 단연코 가장 성공적인 제품이다.",
    type: "superlative intensifier",
  },
  {
    id: 44,
    koreanQuestion:
      "새로운 정책은  _______  가장 효과적인 조치이다 그..조치된 지금까지 ",
    question:
      "The new policy is ______ the most effective measure taken so far.",
    choices: {
      A: "much",
      B: "even",
      C: "simply",
      D: "far",
    },
    correctAnswer: "C",
    explanation:
      "A: much (훨씬) B: even (심지어) C: simply (단순히, 단연코) D: far (멀리)",
    translation:
      "새로운 정책은 지금까지 시행된 조치 중에서 단연 가장 효과적인 조치이다.",
    type: "superlative intensifier",
  },
  {
    id: 45,
    koreanQuestion: "3분기는  _____ 가장 도전적인 시기였다 회사에 있어",
    question:
      "The third quarter was ______ the most challenging period for the company.",
    choices: {
      A: "much",
      B: "quite",
      C: "even",
      D: "far",
    },
    correctAnswer: "B",
    explanation:
      "A: much(훨씬) B: quite(상당히, 꽤) C: even(심지어) D: far(멀리)",
    translation: "3분기는 회사에 있어 상당히 가장 도전적인 시기였다.",
    type: "superlative intensifier",
  },
  {
    id: 46,
    koreanQuestion: "______ 모든 후보, 그녀가 가장 적합했다 그 직책에 ",
    question:
      "______ all the candidates, she was the most suitable for the position.",
    choices: {
      A: "With",
      B: "Of",
      C: "Between",
      D: "Inside",
    },
    correctAnswer: "B",
    explanation:
      "A: With(~와 함께) B: Of(~중에서) C: Between(~사이에서) D: Inside(~안에)",
    translation: "모든 후보 중에서, 그녀가 그 직책에 가장 적합했다.",
    type: "superlative preposition",
  },
  {
    id: 47,
    koreanQuestion: "새로운 시설은 _______ 가장 발전된 시설이다 업계에서",
    question: "The new facility is ______ the most advanced in the industry.",
    choices: {
      A: "much",
      B: "by far",
      C: "even",
      D: "far",
    },
    correctAnswer: "B",
    explanation: "A: much(훨씬) B: by far(단연코) C: even(심지어) D: far(멀리)",
    translation: "새로운 시설은 업계에서 단연 가장 발전된 시설이다.",
    type: "superlative intensifier",
  },

  {
    id: 48,
    koreanQuestion: "마케팅 캠페인은 성과를 냈다 _______ 예상보다",
    question: "The marketing campaign performed ______ than expected.",
    choices: {
      A: "successful",
      B: "successfully",
      C: "more successfully",
      D: "more successful",
    },
    correctAnswer: "C",
    explanation:
      "A: successful(성공적인) B: successfully(성공적으로) C: more successfully(더 성공적으로) D: more successful(더 성공적인)",
    translation: "마케팅 캠페인은 예상보다 더 성공적으로 수행되었다.",
    type: "comparative adverb",
  },
  {
    id: 49,
    koreanQuestion: "그 시스템은 처리한다 많은 양을 데이터  _______ 이전보다",
    question: "The system processes large amounts of data ______ than before.",
    choices: {
      A: "efficient",
      B: "efficiently",
      C: "more efficiently",
      D: "more efficient",
    },
    correctAnswer: "C",
    explanation:
      "A: efficient(효율적인) B: efficiently(효율적으로) C: more efficiently(더 효율적으로) D: more efficient(더 효율적인)",
    translation: "그 시스템은 이전보다 더 효율적으로 데이터를 처리한다.",
    type: "comparative adverb",
  },
  {
    id: 50,
    koreanQuestion: "택배 서비스는 배송했다 택배를 _______ 예상보다",
    question: "The courier service delivered the package ______ than expected.",
    choices: {
      A: "fast",
      B: "faster",
      C: "fastly",
      D: "most fast",
    },
    correctAnswer: "B",
    explanation:
      "A: fast(빠르게) B: faster(더 빠르게) C: fastly(존재하지 않는 단어) D: most fast(가장 빠르게-잘못된 형태)",
    translation: "택배 서비스는 예상보다 더 빠르게 배송되었다.",
    type: "comparative adverb",
  },
  {
    id: 51,
    koreanQuestion: "그 팀은 대응했다 위기에  _______ 평소보다",
    question: "The team responded to the crisis ______ than usual.",
    choices: {
      A: "quick",
      B: "quickly",
      C: "more quickly",
      D: "quicker",
    },
    correctAnswer: "C",
    explanation:
      "A: quick(빠른) B: quickly(빠르게) C: more quickly(더 빠르게) D: quicker(더 빠른)",
    translation: "그 팀은 평소보다 더 신속하게 위기에 대응했다.",
    type: "comparative adverb",
  },
  {
    id: 52,
    koreanQuestion: "그 교수는 설명했다 개념을 _______ 이전보다",
    question: "The professor explained the concept ______ than before.",
    choices: {
      A: "clear",
      B: "clearly",
      C: "more clearly",
      D: "clearer",
    },
    correctAnswer: "C",
    explanation:
      "A: clear(명확한) B: clearly(명확하게) C: more clearly(더 명확하게) D: clearer(더 명확한)",
    translation: "그 교수는 이전보다 더 명확하게 개념을 설명했다.",
    type: "comparative adverb",
  },
  {
    id: 53,
    koreanQuestion: "그의 두 번째 시도는 _____ 더 나았다 첫번쨰 보다",
    question: "His second attempt was a ______ better than the first.",
    choices: {
      A: "most",
      B: "more",
      C: "very",
      D: "little",
    },
    correctAnswer: "D",
    explanation: "A: most(가장) B: more(더) C: very(매우) D: little(약간)",
    translation: "그의 두 번째 시도는 첫 번째보다 약간 더 나았다.",
    type: "comparative intensifier",
  },
  {
    id: 54,
    koreanQuestion: "새 건물은 ____ 더 높다 옜 건물보다",
    question: "The new building is ______ taller than the old one.",
    choices: {
      A: "most",
      B: "very",
      C: "almost",
      D: "considerably",
    },
    correctAnswer: "D",
    explanation:
      "A: most(가장) B: very(매우) - 비교급과 사용 못함 C: almost(거의) D: considerably(상당히)",
    translation: "새 건물은 옛 건물보다 상당히 더 높다.",
    type: "comparative intensifier",
  },
  {
    id: 55,
    koreanQuestion: "이것이 ____ 가장 좋은 해결책이다 향상시키기 위한 효율성을",
    question: "This is ______ the best solution to improve efficiency.",
    choices: {
      A: "very",
      B: "much",
      C: "slightly",
      D: "by far",
    },
    correctAnswer: "D",
    explanation:
      "A: very(매우) - 최상급과 사용 못함 B: much(훨씬) - 비교급 강조 표현C: slightly(약간) D: by far(단연코)",
    translation: "이것이 효율성을 향상시키는 단연코 가장 좋은 해결책이다.",
    type: "superlative intensifier",
  },
  {
    id: 56,
    koreanQuestion: "그녀는 _____ 가장 재능 있는 사람이다 그룹에서",
    question: "She is ______ the most talented in the group.",
    choices: {
      A: "very",
      B: "quite",
      C: "slightly",
      D: "easily",
    },
    correctAnswer: "D",
    explanation:
      "A: very(매우) - 최상급과 사용 못함 B: quite(꽤) - 최상급과 함께 사용 시 의미가 약함 C: slightly(약간) D: easily(틀림없이)",
    translation: "그녀는 그룹에서 틀림없이 가장 재능 있는 사람이다.",
    type: "superlative intensifier",
  },
];
